<template>
  <div id="paypal-button-container"></div>
</template>

<script>
import prepareChoice from "../../utils/prepareReservation";
import stepMixin from "../../utils/mixins/stepMixin";
import { SET_SNACKBAR } from "../../store/snackbar/mutation-types";
import { SET_STEPPER_LOADING } from "../../store/stepper/action-types";
import moment from "../../plugins/moment";

export default {
  mixins: [stepMixin],
  props: {
    gift: {
      type: Boolean,
      default: false,
    },
    nights: {
      type: Boolean,
      default: false,
    },
    extras: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    data: "",
  }),
  computed: {
    paypalClientId() {
      return window.paypal_client_id;
    },
  },
  methods: {
    saveReservation() {},
  },
  created() {
    Vue.loadScript(
      `https://www.paypal.com/sdk/js?client-id=${this.paypalClientId}&currency=EUR`
    ).then(() => {
      let choice = "default";
      if (this.nights) {
        choice = "nights";
      } else if (this.gift) {
        choice = "gift";
      } else if (this.extras) {
        choice = "bonus";
      }
      paypal
        .Buttons({
          createOrder: () => {
            this.$emit("hide-paypal");
            return fetch("/api/paypal/create-order", {
              method: "post",
              headers: {
                "content-type": "application/json",
              },
              body: JSON.stringify({
                reservation: prepareChoice(choice),
                gift: this.gift ? 1 : 0,
                nights: this.nights ? 1 : 0,
                extras: this.extras ? 1 : 0,
                user_timezone: moment.tz.guess(),
              }),
            })
              .then(function (res) {
                return res.json();
              })
              .then(function (data) {
                return data.result.id; // Use the same key name for order ID on the client and server
              })
              .catch((err) => {
                store.dispatch(SET_STEPPER_LOADING, false);
                this.$emit("hide-overlay");
                store.commit(SET_SNACKBAR, {
                  ...store.getters.GET_SNACKBAR,
                  color: "error",
                  text: "Ha ocurrido un error durante el pago",
                  value: true,
                });
              });
          },
          onCancel: (data) => {
            store.dispatch(SET_STEPPER_LOADING, false);
            this.$emit("hide-overlay");
            store.commit(SET_SNACKBAR, {
              ...store.getters.GET_SNACKBAR,
              text: "No se ha completado el pago con Paypal",
              color: "error",
              value: true,
            });
          },
          //TODO: Refactor onApprove method
          onApprove: (data) => {
            this.$emit("paypal-approved");
            return fetch("/api/paypal/capture-order/ok", {
              method: "post",
              headers: {
                "content-type": "application/json",
              },
              body: JSON.stringify({
                orderID: data.orderID,
              }),
            })
              .then(function (res) {
                return res.json();
              })
              .then((res) => {
                //Submit to comfirmation funnel
                const { code } = res.reservation;
                let path;
                if(this.extras){
                  path = `/area-reserva/${code}/confirmacion`;
                }else if (this.gift) {
                  path = `/regala/${code}/confirmacion`;
                } else {
                  path = `/viaje/${code}/confirmacion`;

                  // Temporarily commented out to temporary disable more days trips
                  // path = this.nights
                  //   ? `/mas-de-un-dia/${code}/confirmacion`
                  //   : `/viaje/${code}/confirmacion`;
                }
                router.push(path).then(() => {
                  store.dispatch(SET_STEPPER_LOADING, false);
                  this.$emit("hide-overlay");
                });
              })
              .catch((err) => {
                console.log(err);
                this.$emit("hide-overlay");
                store.dispatch(SET_STEPPER_LOADING, false);
                store.commit(SET_SNACKBAR, {
                  ...store.getters.GET_SNACKBAR,
                  text: "No se ha completado el pago con Paypal",
                  color: "error",
                  value: true,
                });
              });
          },

          style: {
            shape: "pill",
            layout: "horizontal",
            size: "large",
            label: "checkout",
          },
        })
        .render("#paypal-button-container");
    });
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 400px) {
  #paypal-button-container {
    width: 100%;
    height: 100%;
    max-height: 200px;

    .paypal-button-row {
      height: 100% !important;
      max-height: 200px !important;
    }
  }
}

@media screen and (min-width: 400px) {
  #paypal-button-container {
    width: 250px;
    height: 100%;
    max-height: 200px;

    .paypal-button-row {
      height: 100% !important;
      max-height: 200px !important;
    }
  }
}
</style>
